import { IDS } from "./pnp.constants";


export const mainState = {
    name: IDS.app_policies,
    abstract: true,
    url: '/policies'
};

export const dashboardState = {
    name: IDS.app_policies_dashboard,
    url: '',
    component: 'dashboard'
};

export const settingsState = {
    name: IDS.app_policies_settings,
    abstract: true,
    url: '/settings'
};

export const documentsState = {
    name: IDS.app_policies_documents,
    abstract: true,
    url: '/documents'
};